import { defineStore } from "pinia";
import { ApiSup } from "@/Functions/ApiSupport";
import { Redo } from "lucide-vue-next";
import { th } from "date-fns/locale";

export const useGradeStore = defineStore('useGradeStore',{
  state: () => ({
    grade: [],
  }),
  actions:{
    async addGrade(body){
            const apiSup = ApiSup()
            const ret = await apiSup.postSupport('api/grade_level/',body)

            return ret
    },
    async getGrades(){
            const apiSup = ApiSup()
            const ret = await apiSup.getSupport('api/grade_level/')
            this.grade = ret.data
    },
    async updateGrade(body,id){
        const apiSup = ApiSup()
        const ret = await apiSup.putSupport('api/grade_level/' + id, body)

        return ret
    },
    async deleteGrade(id){
      const apiSup = ApiSup()

      const ret = await apiSup.deleteSupport('api/grade_level/' + id)
      return ret
    }

  }
})
